import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { submit } from 'redux-form';
import { hideDialog } from '../../../core/actions';
import ModalDialog from '../../../core/components/Modal';
import TodaysTaskInDetail from '../components/TodaysTaskInDetail';
import { TaskDetails } from '../components/TaskDetails';
import { useFeatureFlag } from '../../../core/hooks/useFeatureFlag';

const TaskDetailsDialog = ({ closeDialog, isOpen, taskCompletion, title, match, history }) => {
  const taskDetailsV2Enabled = useFeatureFlag('task-details-v2', false);

  return (
    <ModalDialog
      className="enhanced-dialog padded-minimal task-details"
      title={title}
      showFooter={false}
      isOpen={isOpen}
      close={closeDialog}
    >
      {taskDetailsV2Enabled ? (
        <TaskDetails taskId={taskCompletion.task.id} onClose={closeDialog} />
      ) : (
        <TodaysTaskInDetail
          {...taskCompletion.task}
          match={match}
          history={history}
          _taskId={taskCompletion.task.id}
          hideDrawerControls={true}
        />
      )}
    </ModalDialog>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      closeDialog: hideDialog,
      triggerSubmit: submit,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskDetailsDialog);
